module.exports = __webpack_public_path__ + "img/text.e7f69c1c.png";